module.exports = __webpack_public_path__ + "static/media/2000-point-season.787b2cec.png";